module.exports = __webpack_public_path__ + "static/sample-19-cbc3a155483263fcaef9e19c7cb16c86.png";